import React from 'react';
import PropTypes from 'prop-types';
import Rating from '@material-ui/lab/Rating';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@material-ui/icons/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import {
  Card,
  Typography
} from '@material-ui/core';

function SatisfactionRating({funcRatingValue}){
  const [value, setValue] = useState(0);
  const { t } = useTranslation('work_order');

  const handleChange = (event, newValue) => {
    setValue(newValue);
    funcRatingValue(newValue);
  }

  const customIcons = {
    1: {
      icon: <SentimentVeryDissatisfiedIcon style={{fontSize:'40px'}}/>,
      label: 'Very Dissatisfied',
    },
    2: {
      icon: <SentimentDissatisfiedIcon style={{fontSize:'40px'}}/>,
      label: 'Dissatisfied',
    },
    3: {
      icon: <SentimentSatisfiedIcon style={{fontSize:'40px'}}/>,
      label: 'Neutral',
    },
    4: {
      icon: <SentimentSatisfiedAltIcon style={{fontSize:'40px'}}/>,
      label: 'Satisfied',
    },
    5: {
      icon: <SentimentVerySatisfiedIcon style={{fontSize:'40px'}}/>,
      label: 'Very Satisfied',
      
    },
  };

  function IconContainer(props) {
    const { value, ...other } = props;
    return <span {...other}>{customIcons[value].icon}</span>;
  }
  
  IconContainer.propTypes = {
    value: PropTypes.number.isRequired,
  };

  return (
    <Card style={{padding:'5px'}}>
      <Typography variant="overline" display="block" gutterBottom>{t('lblSatisfactionRatingHeader')}</Typography>
      <br/>
      <Rating 
        name="highlight-selected-only"
        value={value} 
        onChange={handleChange}
        IconContainerComponent={IconContainer}
        highlightSelectedOnly
      /> 
    </Card>
  )
}

export default SatisfactionRating;

